export default {
  color: "blue",
};
